import { type ViolationsWidgetMenuItemOption } from '../components/ViolationsWidgets';

export const moveArrayItem = (
  array: ViolationsWidgetMenuItemOption[],
  fromIndex: number,
  toIndex: number
) => {
  const newArray = [...array];
  const [moved] = newArray.splice(fromIndex, 1);

  newArray.splice(toIndex, 0, moved);

  return newArray;
};

export default moveArrayItem;
